var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C5 3.625 4.25 4.59375 3.25 4.90625V8C3.875 7.53125 4.625 7.25 5.5 7.25H8.5C9.71875 7.25 10.75 6.25 10.75 5V4.90625C9.71875 4.59375 9 3.625 9 2.5C9 1.125 10.0938 0 11.5 0C12.875 0 14 1.125 14 2.5C14 3.625 13.25 4.59375 12.25 4.90625V5C12.25 7.09375 10.5625 8.75 8.5 8.75H5.5C4.25 8.75 3.25 9.78125 3.25 11V11.125C4.25 11.4375 5 12.4062 5 13.5C5 14.9062 3.875 16 2.5 16C1.09375 16 0 14.9062 0 13.5C0 12.4062 0.71875 11.4375 1.75 11.125V4.90625C0.71875 4.59375 0 3.625 0 2.5C0 1.125 1.09375 0 2.5 0C3.875 0 5 1.125 5 2.5ZM2.5 3.5C3.03125 3.5 3.5 3.0625 3.5 2.5C3.5 1.96875 3.03125 1.5 2.5 1.5C1.9375 1.5 1.5 1.96875 1.5 2.5C1.5 3.0625 1.9375 3.5 2.5 3.5ZM11.5 1.5C10.9375 1.5 10.5 1.96875 10.5 2.5C10.5 3.0625 10.9375 3.5 11.5 3.5C12.0312 3.5 12.5 3.0625 12.5 2.5C12.5 1.96875 12.0312 1.5 11.5 1.5ZM2.5 14.5C3.03125 14.5 3.5 14.0625 3.5 13.5C3.5 12.9688 3.03125 12.5 2.5 12.5C1.9375 12.5 1.5 12.9688 1.5 13.5C1.5 14.0625 1.9375 14.5 2.5 14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchIcon);
export default __webpack_public_path__ + "static/media/branch-icon.9fcfabfc42ecb64c140edc895ed1b155.svg";
export { ForwardRef as ReactComponent };